import PropTypes from 'prop-types';

/**
 * @description This function takes in a list of weighted objects and a list of lookup objects, and returns the weighted object with the greatest weight that matches a lookup object by name. If there are no matches, it returns null.
 * @param {Array<{name: string, weight: number}>} weightedObjects
 * @param {Array<{name: string}>} lookupObjects
 * @returns {Object|null}
 */
export const findGreatestWeightedMatch = (weightedObjects, lookupObjects) => {
  if (!weightedObjects || (weightedObjects?.length || 0) === 0) {
    return null;
  }

  if (!lookupObjects || (lookupObjects?.length || 0) === 0) {
    return null;
  }
  let currentObject = null;
  // Start looping the available sample objects
  for (let lookupObject of lookupObjects) {
    // For each sample object, loop the weighted objects
    for (let weightedObject of weightedObjects) {
      // If the sample object name matches the weighted name
      if (lookupObject.name === weightedObject.name) {
        // If we don't have a current object, or the weighted object has a higher weight than the current object
        if (!currentObject) {
          currentObject = weightedObject;
        } else if (weightedObject.weight > currentObject.weight) {
          currentObject = weightedObject;
        }
      }
    }
  }
  return currentObject;
};

PropTypes.findGreatestWeightedMatch = {
  weightedObjects: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      weight: PropTypes.number.isRequired,
    })
  ).isRequired,
  lookupObjects: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
    })
  ).isRequired,
};
